import { z } from 'zod'
import { ServiceLogOperation } from '~/enums/service-log-operation'

/**
 * 問題答覆記錄 - 新增 Request Schema
 */
export const createServiceLogRequestSchema = z.object({
  /** 問題主檔ID */
  siID: z.number(),
  /** 執行動作 */
  operation: z.nativeEnum(ServiceLogOperation).optional(),
  /** 問答內容 */
  operationContent: z.string().optional(),
  /** 技術人員帳號 */
  accountNo: z.string().optional()
})

/**
 * 問題答覆記錄 - 新增 Request
 */
export interface CreateServiceLogRequest
  extends z.infer<typeof createServiceLogRequestSchema> {}
